import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../helper/apiCall";
import ENDPOINTS from "../../constants/endpoints";

const initialState = {
    loading: false,
    branches: [],
    selectedBranch: null,
    selectedPlace: null,
    error: null
};

export const getBranches = createAsyncThunk(
    "getBranches",
    async (_, thunkAPI) => {
        try {       
            const response = await client.get(ENDPOINTS.BRANCHES.GET_LIST, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const deleteBranch = createAsyncThunk(
    "deleteBranch",
    async (id, thunkAPI) => {
        try {
            const response = await client.delete(ENDPOINTS.BRANCHES.DELETE.replace(':id', id), null, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const addBranch = createAsyncThunk(
    "addBranch",
    async (body, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.BRANCHES.CREATE, body, {
                token: thunkAPI.getState().auth.token
            });
            
            // Response'dan gelen id ile request body'yi birleştir
            const result = {
                id: response.data.id,
                name: body.name,
                activeStudents: 0 // Varsayılan değer
            };
            return result;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const updateBranch = createAsyncThunk(
    "updateBranch",
    async (body, thunkAPI) => {
        try {
            const response = await client.put(ENDPOINTS.BRANCHES.UPDATE, body, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const getBranchById = createAsyncThunk(
    "getBranchById",
    async (id, thunkAPI) => {
        try {
            const response = await client.get(ENDPOINTS.BRANCHES.GET_BY_ID.replace(':id', id), {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

const branchesSlice = createSlice({
    name: "branches",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearSelectedBranch: (state) => {
            // Şube branşa bağlı olduğu için branş bırakılınca şube de düşer.
            state.selectedBranch = null;
            state.selectedPlace = null;
        },
        setSelectedBranch: (state, action) => {
            const previousId = state.selectedBranch?.id;
            state.selectedBranch = action.payload;
            if (previousId !== action.payload?.id) {
                state.selectedPlace = null;
            }
        },
        clearSelectedPlace: (state) => {
            state.selectedPlace = null;
        },
        setSelectedPlace: (state, action) => {
            state.selectedPlace = action.payload;
        }
    },
    extraReducers(builder) {
        builder.addCase(getBranches.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getBranches.fulfilled, (state, action) => {
            state.loading = false;
            state.branches = action.payload;
        });
        builder.addCase(getBranches.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(deleteBranch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(deleteBranch.fulfilled, (state, action) => {
            state.loading = false;
            // Silinen branch'i listeden çıkar
        });
        builder.addCase(deleteBranch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(addBranch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(addBranch.fulfilled, (state, action) => {
            state.loading = false;
            // Yeni branch'i listeye ekle
        });
        builder.addCase(addBranch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(getBranchById.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getBranchById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedBranch = action.payload;
        });
        builder.addCase(getBranchById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(updateBranch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(updateBranch.fulfilled, (state, action) => {
            state.loading = false;
            // Güncellenen branch'i listede güncelle
            
        });
        builder.addCase(updateBranch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { clearError, clearSelectedBranch, setSelectedBranch, clearSelectedPlace, setSelectedPlace } = branchesSlice.actions;
export default branchesSlice.reducer; 